const UPLOAD_VIDEO_ENDPOINT =
  process.env.REACT_APP_UPLOAD_API_URL || "/api/upload-video";

export default UPLOAD_VIDEO_ENDPOINT;
